import { useAuthStore } from '@/stores/authStore';

// Global logout handler that can be called from anywhere
let globalLogoutHandler: (() => Promise<void>) | null = null;

// Register the logout handler (called from React context)
export function registerLogoutHandler(handler: () => Promise<void>) {
  globalLogoutHandler = handler;
}

// Unregister the logout handler
export function unregisterLogoutHandler() {
  globalLogoutHandler = null;
}

// Logout promise for debouncing
let logoutPromise: Promise<void> | null = null;

// Perform logout with debouncing
export async function performLogout(): Promise<void> {
  // If logout is already in progress, wait for it
  if (logoutPromise) {
    return logoutPromise;
  }

  // Start the logout process
  logoutPromise = (async () => {
    try {
      // Use the registered logout handler if available (includes Privy logout)
      if (globalLogoutHandler) {
        await globalLogoutHandler();
      } else {
        // Fallback to just clearing the store if no handler is registered
        const authStore = useAuthStore.getState();
        authStore.logout();
      }
    } catch (error) {
      console.error('Logout failed:', error);
      // Even if logout fails, clear the local state
      const authStore = useAuthStore.getState();
      authStore.logout();
    } finally {
      logoutPromise = null;
    }
  })();

  return logoutPromise;
}